/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.14.0
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Button, LinkBlock } from '../../../components/common';
import { ImgStatusSuccess } from '../../../components/common/Block/Img';
import { getPageOrderIdUrl, isPageOrderIdExternalUrl } from '../../../pages/PageOrderId/utils/getPageOrderIdUrl';
import { IRootReducer } from '../../../reducers/rootReducer';
import { RoutePath } from '../../../routes/constants/routesConstants';
import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import { ICommonTranslation } from '../../internationalization/types';
import { guardComponentType } from '../../role/reducer/guardReducer';
import { makeSelectGuardComponents } from '../../role/selectors/guardSelector';
import { IModalRenderProps } from '../types/modalTypes';
import Modal from './Modal';
import { ModalCenterStyled } from './styled/ModalCenterStyled';

interface IModalOrder extends Pick<IModalRenderProps, 'onCloseModal'> {
    orderId?: number | string;
    orderName?: string;
    onCloseButtonClick?: () => void;
}

const ModalOrder = ({
    componentsFeature,
    orderId,
    orderName,
    onCloseModal,
    onCloseButtonClick,
    translationCommon,
}: IModalOrder & IConnectedProps) => {
    const orderUrl = orderId ? getPageOrderIdUrl(componentsFeature, orderId) : '';

    return (
        <ModalCenterStyled>
            <ImgStatusSuccess />
            <Modal.Title>
                {translationCommon.modalOrder.orderMessageStart}&nbsp;
                <br />
                {orderId ? (
                    <LinkBlock isExternalUrl={isPageOrderIdExternalUrl(componentsFeature)} url={orderUrl}>
                        {orderName || orderId}
                    </LinkBlock>
                ) : (
                    orderName
                )}
                <br />
                {translationCommon.modalOrder.orderMessageEnd}
            </Modal.Title>
            <Modal.Text>
                {translationCommon.modalOrder.details}&nbsp;
                <LinkBlock url={RoutePath.orders}>«{translationCommon.pages.historyOrder}»</LinkBlock>
            </Modal.Text>
            <Modal.Control>
                <Button dataName="modal-order-ok" kind="medium" onClick={onCloseButtonClick || onCloseModal}>
                    {translationCommon.modal.good}
                </Button>
            </Modal.Control>
        </ModalCenterStyled>
    );
};

interface IConnectedProps {
    componentsFeature: guardComponentType;
    translationCommon: ICommonTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    componentsFeature: makeSelectGuardComponents(),
    translationCommon: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(ModalOrder);
